export default "__VITE_ASSET__C2R1C$jg__"